import FeedbackModal from './FeedbackModal';

const ARGOS_TRADERBOT_SITE = 'https://argostraderbot.com';

function Footer() {
    return (
        <>
            <footer className="bg-white rounded shadow p-5 mb-4 mt-4">
                <div className="row">
                    <div className="col-12 col-md-4 col-xl-6 mb-4 mb-md-0">
                        <p className="mb-0 text-center text-lg-start">
                            ©{' '}
                            <span className="current-year">
                                {new Date().getFullYear()}
                            </span>{' '}
                            <a
                                className="text-primary fw-normal"
                                href={`${ARGOS_TRADERBOT_SITE}`}
                            >
                                Argos TraderBot
                            </a>
                        </p>
                    </div>
                    <div className="col-12 col-md-8 col-xl-6 text-center text-lg-start">
                        <ul className="list-inline list-group-flush list-group-borderless text-md-end mb-0">
                            <FeedbackModal />
                        </ul>
                    </div>
                </div>
            </footer>
        </>
    );
}

export default Footer;
